import AssetDocuments from "./AssetDocuments";

export default function EmployeeDocuments({ employeeId }) {
  return <AssetDocuments ownerType="EMPLOYEE" ownerId={employeeId} />;
}
